import { GetAuthUrlInteractor } from '../../auth/domain/interactors/get-auth-url.interactor';

export class GetDropboxAuthUrlInteractor implements GetAuthUrlInteractor {
  constructor(
    private readonly clientId: string,
    private readonly redirectUri: string,
  ) {}

  public execute(state: string, pkceChallenge: string, forceConsent: boolean): string {
    // See: https://developers.dropbox.com/oauth-guide
    // See: https://www.dropbox.com/developers/documentation/http/documentation#oauth2-authorize
    const params = [
      `client_id=${this.clientId}`,
      `code_challenge_method=S256`,
      `code_challenge=${pkceChallenge}`,
      `redirect_uri=${encodeURIComponent(this.redirectUri)}`,
      `response_type=code`,
      forceConsent ? `prompt=consent` : undefined,
      `state=${state}`,
      `token_access_type=offline`,
    ]
      .filter((param) => !!param)
      .join('&');

    return `https://www.dropbox.com/oauth2/authorize?${params}`;
  }
}
